import { Directive, Input } from '@angular/core';
import { FormControl, Validator, NG_VALIDATORS } from '@angular/forms';

@Directive({
  selector: '[max][formControlName],[max][formControl], [max][ngModel]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: MaxValidatorDirective, multi: true }
  ]
})
export class MaxValidatorDirective implements Validator {
  @Input() max: number;

  constructor() {}

  validate(c: FormControl): { [key: string]: any } {
    return c.value > this.max ? { max: true } : null;
  }
}
